export default {
      id: "i-logo-kids-usage",
      viewBox: "0 0 140 40",
      url: __webpack_public_path__ + "img/sprite.svg#i-logo-kids",
      toString: function () {
        return this.url;
      }
    }